const getBrowserLanguage = (): string => navigator.language;

export { getBrowserLanguage };
